import React, { Suspense } from 'react';
import { useTranslation } from 'react-i18next';
import Grid from '@mui/material/Grid';
import { makeStyles } from '@mui/styles';
import { useTheme } from '@mui/material/styles';
import Paper from '@mui/material/Paper';
import { Container, Row, Col } from 'react-bootstrap';
import '../styles.css';
import Loader from '../../../loader.js';
import Header from '../../../header.js';
import FooterMenu from '../../../FooterMenu.js';
import Footer from '../../../footer.js';
import './../../../global.css';
import '../../breadcrumb.css';
import '../../../../node_modules/bootstrap/dist/css/bootstrap.min.css';
import Mapa from './mapa';

function handleClick(event) {
  event.preventDefault();
  console.info('You clicked a breadcrumb.');
}

const useStyles = makeStyles(() => ({
  root: {
    flexGrow: 1,
  },
  header: {
    padding: useTheme().spacing(4.6),
    textAlign: 'center',
    color: useTheme().palette.text.secondary,
    backgroundColor: 'white',
  },
  title: {
    padding: useTheme().spacing(5),
    textAlign: 'left',
    color: useTheme().palette.text.secondary,
    backgroundColor: '#135EA7',
  },
  breadcrumb: {
    padding: useTheme().spacing(5),
    textAlign: 'right',
    color: useTheme().palette.text.secondary,
    backgroundColor: '#135EA7',
  },
  body: {
    padding: useTheme().spacing(5),
    textAlign: 'justify',
    backgroundColor: 'white',
  },
}));

function Page() {
  const classes = useStyles();
  const { t } = useTranslation();
  return (
    <div className={classes.root}>
      <Grid container spacing={0}>
        <Grid item xs={12}>
          <Paper className={classes.header} square>
            <Header />
          </Paper>
        </Grid>

        <Grid item xs={12} className="subHeader">
          <Container>
            <Row id="crumbsMenu" className="justify-content-md-start">
              <Col xs lg="5" className={classes.title} id="tituloSubHeader" sm={6}>
                {t('Rede Veredas')}
              </Col>
            </Row>
          </Container>
        </Grid>

        <Grid item xs={12} style={{ backgroundColor: '#fff' }}>
          <Container>
            <Row className="justify-content-md-center">
              <Col id="texto-recursos" xs lg="10" className={classes.body}>
                <p className="infraP">
                  A Rede <span id="spotName">Veredas</span> é uma iniciativa da Rede Nacional de Ensino e Pesquisa (RNP)
                  no estado de Pernambuco, que tem como objetivo ampliar o acesso à banda larga para instituições de
                  ensino e pesquisa localizadas no interior do estado, através de circuitos contratados por operadoras
                  comerciais para interconectar tais instituições ao PoP-PE. Com isso, permite acesso a serviços
                  digitais, como ensino à distância e telemedicina, além de contribuir para a inclusão digital e para o
                  desenvolvimento da comunidade acadêmica local.


                <Mapa></Mapa>



                  <p id="netRef">
                    <p className="cardItem">
                      Fontes:
                      <a
                        className="linkContact"
                        target="_blank"
                        rel="noopener noreferrer"
                        href="https://memoria-veredasnovas.rnp.br/veredasnovas/perguntas-mais-frequentes.html"
                      >
                        <b className="linkRef"> memoria-veredasnovas.rnp.br/veredasnovas</b>
                      </a>
                    </p>
                  </p>
                </p>
                <br />
                {/* <img id="mapaVeredas" className="infraImg" src={repepe} alt="Mapa RePEPE" /> */}

                

                <br />
                <br />
              </Col>
            </Row>
          </Container>
        </Grid>
        <Grid item xs={12} className="footer-menu-background">
          <FooterMenu />
        </Grid>

        <Grid item xs={12} className="footer-background">
          <Footer />
        </Grid>
      </Grid>
    </div>
  );
}

export default function App() {
  return (
    <Suspense fallback={<Loader />}>
      <Page />
      {/* <Loader /> */}
    </Suspense>
  );
}
